import { useGET } from '../shared/hooks/useGET';
import { createLineupsExplorerQueryString } from './createLineupsExplorerQueryString';

const toUrl = (leagueId, teamId, query) =>
  `/league/${leagueId}/team/${teamId}/lineups/analysis${query}`;

export function useFilteredLineupExplorerAnalysis(
  leagueId,
  seasonId,
  teamId,
  gameId,
  time,
  players,
) {
  const query = createLineupsExplorerQueryString(
    seasonId,
    gameId,
    time,
    players,
  );

  const url = toUrl(leagueId, teamId, query);
  return useGET(url);
}
